<template>
  <div v-if="isLoading">
    <Button variant="ghost" class="relative h-8 w-8 rounded-full">
      <Avatar class="h-9 w-9">
        <AvatarFallback>
          <Icon name="lucide:loader" class="h-5 w-5 animate-spin" />
        </AvatarFallback>
      </Avatar>
    </Button>
  </div>
  <DropdownMenu v-else v-model:open="isOpen">
    <DropdownMenuTrigger as-child>
      <Button variant="ghost" class="relative h-8 w-8 rounded-full">
        <Avatar class="h-9 w-9">
          <AvatarImage :src="userStore.avatarUrl || userStore.defaultAvatarUrl" :alt="name" />
          <AvatarFallback>
            <Icon name="lucide:user" class="h-5 w-5" />
          </AvatarFallback>
        </Avatar>
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent class="w-56" align="end">
      <DropdownMenuLabel class="font-normal flex">
        <div class="flex flex-col space-y-1">
          <p class="text-sm font-medium leading-none">
            {{ name }}
          </p>
          <p class="text-xs leading-none text-muted-foreground">
            {{ email }}
          </p>
        </div>
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuGroup>
        <DropdownMenuItem @click="navigateTo('/dashboard/home')"> Dashboard </DropdownMenuItem>
        <DropdownMenuItem @click="navigateTo('/settings/profile')"> Profile </DropdownMenuItem>
        <DropdownMenuItem @click="navigateTo('/dashboard/sharing')"> Sharing </DropdownMenuItem>
        <!-- <DropdownMenuItem @click="navigateTo('/settings/billing')"> Billing </DropdownMenuItem> -->
        <DropdownMenuItem @click="navigateTo('/settings/account')"> Settings </DropdownMenuItem>
        <DropdownMenuItem @click="navigateTo('/help')"> Help & Downloads </DropdownMenuItem>
      </DropdownMenuGroup>
      <DropdownMenuSeparator />
      <DropdownMenuItem @click="userStore.logout"> Log out </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'

const userStore = useUserStore()
const router = useRouter()
const { isLoading, name, email } = storeToRefs(userStore)
const isOpen = ref(false)

const navigateTo = (path: string) => {
  router.push(path)
}
</script>
